import { useTranslation } from 'react-i18next'
import { PlayMicIcon } from '../icons'
import NotFoundCard from '../NotFoundCard'
import { Pie } from '@visx/shape'
import { Group } from '@visx/group'

const colors = ['#80d3fd', '#66B3E4', '#377FCC', '#1A5DB8', '#0E3A91', '#0166FF', '#5D4DEB']

const PieChart = ({ topViewContent }: any) => {
    const width = 112
    const height = 112
    const radius = Math.min(width, height) / 2

    const data = topViewContent.map((item: any, index: number) => ({
        label: item.label,
        value: item.value,
        color: colors[index]
    }))

    return (
        <svg width={width} height={height}>
            <Group top={height / 2} left={width / 2}>
                <Pie data={data} pieValue={(d: any) => d.value} outerRadius={radius} cornerRadius={0} padAngle={0}>
                    {(pie) =>
                        pie.arcs.map((arc, index) => {
                            const [centroidX, centroidY] = pie.path.centroid(arc)
                            const color = data[index].color

                            return (
                                <g key={`arc-${index}`}>
                                    <path d={pie.path(arc) ?? undefined} fill={color} />
                                    <text x={centroidX} y={centroidY} dy=".33em" fontSize={10} textAnchor="middle" fill="#fff">
                                        {index + 1}
                                    </text>
                                </g>
                            )
                        })
                    }
                </Pie>
            </Group>
        </svg>
    )
}

function Curiosities({ curiosities }: any) {
    const { t } = useTranslation()
    const topViewContent = curiosities?.top_viewed_content
        ? Object.entries(curiosities?.top_viewed_content)
              .map(([label, value], index) => ({
                  label,
                  value,
                  color: ['#8ED6F9', '#66B3E4', '#377FCC', '#1A5DB8', '#0E3A91'][index]
              }))
              .sort((a: any, b: any) => b.value - a.value)
        : []

    if (!curiosities) return null
    return (
        <div className="flex flex-col gap-4 p-6 bg-[#F7F8FC]  h-full overflow-y-auto rounded text-[12px] text-[#51525F] leading-4 w-[338px]">
            <p className="font-semibold text-[18px] mb-4">{t('appEnabled.curiosities')}</p>

            <div className="bg-white p-4 flex items-center justify-between rounded">
                <div className="w-full">
                    <p className=" font-semibold mb-4">{t('appEnabled.top_5_content_watched')}</p>
                    {curiosities?.top_viewed_content ? (
                        <div className="flex flex-col gap-1">
                            {topViewContent.map((key, index) => (
                                <div className="flex gap-1 min-w-[129px]">
                                    <p className="w-[14px]">{index + 1}.</p>
                                    <p>{key.label}</p>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <NotFoundCard />
                    )}
                </div>

                {curiosities?.top_viewed_content && (
                    <div className="w-[112px] h-[112px] ">
                        <PieChart topViewContent={topViewContent} />
                    </div>
                )}
            </div>

            <div className="bg-white p-4 flex rounded flex-col">
                <p className=" font-semibold mb-4">{t('appEnabled.most_popular_baby_name')}</p>
                {curiosities?.most_popular_baby_name ? (
                    <>
                        <div className="p-4 bg-[#F7F8FC] rounded">
                            <p className="text-[18px] text-[#0166FF] font-bold">É {Object.keys(curiosities?.most_popular_baby_name)[0]}!</p>
                        </div>
                        <p className="text-[10px] mt-4">{t('appEnabled.other_popular_names')}</p>
                        <p className="text-[10px] ">
                            {Object.keys(curiosities?.most_popular_baby_name).map((key, index) => (
                                <span>
                                    {index + 1}. {key};{' '}
                                </span>
                            ))}
                        </p>
                    </>
                ) : (
                    <NotFoundCard />
                )}
            </div>

            <div className="bg-white p-4 flex items-center justify-between rounded">
                <div className="w-full">
                    <p className=" font-semibold mb-4">{t('appEnabled.did_you_know_videos_podcasts')}</p>
                    {curiosities?.most_viewed_content_type ? (
                        <div className="flex flex-col gap-1">
                            <div>
                                <p>
                                    {curiosities?.most_viewed_content_type?.article} {t('appEnabled.articles_read')}
                                </p>
                                <p>
                                    {curiosities?.most_viewed_content_type?.video} {t('appEnabled.videos_podcasts_watched')}
                                </p>
                            </div>
                        </div>
                    ) : (
                        <NotFoundCard />
                    )}
                </div>

                {curiosities?.most_viewed_content_type && (
                    <div className="w-[112px] h-[112px]">
                        <PlayMicIcon />
                    </div>
                )}
            </div>
        </div>
    )
}

export default Curiosities
